module.exports = __webpack_public_path__ + "static/media/6.14b2c291.png";